import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { MonthlyReportComponent } from './monthly-report.component';

@Injectable()
export class MonthlyReportDialog {
  readonly #dialog = inject(DialogService);

  open(injector: Injector): DialogRef {
    return this.#dialog.open(MonthlyReportComponent, null, { parentInjector: injector });
  }
}
